import React from 'react';
import PropTypes from 'prop-types';
import './Overlay.css';
import xIcon from 'assets/icons/overlay-x.svg';
import lealHealthIcon from 'assets/logo_new.svg';

const Overlay = (props) => {
  const {
    children, onclose, className, hideCloseButton, hideTop,
  } = props;
  return (
    <div className={`overlay ${className || ''}`}>
      {!hideTop && (
        <div className="overlay-top">
          <div className="logo-pos">
            <img
              alt="arrow button"
              src={lealHealthIcon}
            />
          </div>
          {!hideCloseButton && (
            <div className="overlay-close" onClick={onclose}>
              <img alt="close" src={xIcon} />
            </div>
          )}
        </div>
      )}
      <div className="overlay-main">
        {children}
      </div>
    </div>
  );
};

Overlay.propTypes = {
  children: PropTypes.node.isRequired,
  onclose: PropTypes.func,
  className: PropTypes.string,
  hideTop: PropTypes.bool,
  hideCloseButton: PropTypes.bool,
};

export default Overlay;
